'use client';

import Login from '@/components/Login';
import { login as loginAction, otp as otpAction } from './actions';

export default function Page() {
  return <Login loginAction={loginAction} otpAction={otpAction} />;
}
